// extracted by mini-css-extract-plugin
export default {"answer":"CompleteAnswer_answer__0zg59","answerFail":"CompleteAnswer_answerFail__jAw73 CompleteAnswer_answer__0zg59","comment":"CompleteAnswer_comment__3wKdU"};